<div class="container innerContent pt-0 pb-0">
  <div class="mb-2" *ngFor="let section of sections; let sectionIndex = index">
    <div [innerHTML]="section.heading | mdToHtml"></div>
    <div class="accordion card" [ngClass]="toggleMap.get(collapsedStatusArray[sectionIndex]).sectionBorderTopClass">
      <div class="card-header">
        <h4 (click)="toggleCollapsed(sectionIndex)" class="flex-text">
          <div [ngClass]="toggleMap.get(collapsedStatusArray[sectionIndex]).arrowIconsClass" class="arrow-icon"></div>
          <span [ngClass]="toggleMap.get(collapsedStatusArray[sectionIndex]).activeClass">{{ section.title }}</span>
        </h4>
      </div>
      <div [ngClass]="toggleMap.get(collapsedStatusArray[sectionIndex]).accordionClass" class="collapsible card-body" [innerHTML]="section.body | mdToHtml"></div>
    </div>
  </div>
</div>
